import React from 'react'

import { useAdvancedFiltersContextListHeaderState } from './hooks/useAdvancedFiltersContextListHeaderState'
import { AdvancedFiltersContextProvider } from './AdvancedFiltersContext'

export const AdvancedFiltersContextListHeader: React.FC = ({ children }) => {
    const {
        recommendedFieldSids,
        inlineFilters,
        availableFields,
        addInlineFilter,
        removeInlineFilter,
        updateInlineFilter,
        setInlineFilters,
        clearInlineFilters,
    } = useAdvancedFiltersContextListHeaderState()

    return (
        <AdvancedFiltersContextProvider
            filters={inlineFilters}
            fields={availableFields}
            addFilter={addInlineFilter}
            removeFilter={removeInlineFilter}
            updateFilter={updateInlineFilter}
            setFilters={setInlineFilters}
            clearFilters={clearInlineFilters}
            recommendedFieldSids={recommendedFieldSids}
        >
            {children}
        </AdvancedFiltersContextProvider>
    )
}
